import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useCallback, useState } from 'react';
import { Menu, MenuList } from '@material-ui/core';
import { useMediaQueries } from '../../MediaQueries';
import { useDevice } from '../../providers/Device';
import { isTestMode } from '../../utils/test-mode';
import { Box } from '../Layout';
import { DropdownMenuItem } from './DropdownMenu';
import { useDropdownMenuStyles } from './DropdownMenu.styles';
export function DropdownSubMenu(props) {
    const { label, children, iconStart, disabled, hAlign = 'right', testId } = props, biProps = _object_without_properties(props, [
        "label",
        "children",
        "iconStart",
        "disabled",
        "hAlign",
        "testId"
    ]);
    const { isMobileDevice } = useDevice();
    const { smallerThanTablet } = useMediaQueries();
    const expandsInline = isMobileDevice || smallerThanTablet;
    const [anchorEl, setAnchorEl] = useState(null);
    const overrides = useDropdownMenuStyles({
        minWidth: 'auto'
    });
    const toggle = useCallback((event)=>{
        const trigger = event.currentTarget;
        setAnchorEl((current)=>current == null ? trigger : null);
    }, []);
    const close = useCallback(()=>setAnchorEl(null), []);
    const triggerTestId = testId != null ? "".concat(testId, "-trigger") : undefined;
    const inlinePanelTestId = testId != null ? "".concat(testId, "-panel-inline") : undefined;
    const flyoutPanelTestId = testId != null ? "".concat(testId, "-panel-flyout") : undefined;
    const isExpanded = anchorEl != null;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(DropdownMenuItem, _object_spread_props(_object_spread({
                testId: triggerTestId,
                iconStart: iconStart,
                disabled: disabled,
                closeOnClick: false,
                onClick: toggle
            }, biProps), {
                children: label
            })),
            expandsInline ? isExpanded && /*#__PURE__*/ _jsx(Box, {
                testId: inlinePanelTestId,
                padding: 0,
                children: /*#__PURE__*/ _jsx(MenuList, {
                    disablePadding: true,
                    children: children
                })
            }) : isExpanded && /*#__PURE__*/ _jsx(Menu, {
                classes: {
                    paper: overrides.menu
                },
                anchorEl: anchorEl,
                open: isExpanded,
                autoFocus: false,
                onClose: close,
                getContentAnchorEl: null,
                transitionDuration: isTestMode ? 0 : 'auto',
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: hAlign === 'right' ? 'right' : 'left'
                },
                transformOrigin: {
                    vertical: 'top',
                    horizontal: hAlign === 'right' ? 'left' : 'right'
                },
                "data-testid": flyoutPanelTestId,
                children: children
            })
        ]
    });
}
